var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('impact-section-page',{attrs:{"section-id":_setup.IMPACT_SECTION_IDS.impactProfile,"context":_setup.TemplateEngineContext.ImpactSolution,"title":_vm.$t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.title'),"impact-goal":_vm.impactGoal,"impact":_vm.impact,"impact-solution":_vm.impactSolution,"rounded":""},scopedSlots:_vm._u([{key:"intro",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(
        _setup.renderTrustedMarkdown(
          _vm.$t(
            'impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.body',
          ),
        )
      )}}),_vm._v(" "),_c('a',{staticClass:"mt-4 d-inline-block",on:{"click":function($event){_setup.showIntroductionImpactProfile = !_setup.showIntroductionImpactProfile}}},[_c('div',[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v("\n          "+_vm._s(_setup.showIntroductionImpactProfile ? 'mdi-chevron-up' : 'mdi-chevron-down')+"\n        ")]),_vm._v("\n        "+_vm._s(_vm.$t(
            'impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.introductionImpactProfile',
          ))+"\n      ")],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(_setup.showIntroductionImpactProfile)?_c('v-alert',{staticClass:"mb-4",attrs:{"outlined":"","color":"primary"},domProps:{"innerHTML":_vm._s(
        _setup.renderTrustedMarkdown(
          _vm.$t(
            'impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.introductionImpactProfileContent',
          ),
        )
      )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-4",domProps:{"innerHTML":_vm._s(
        _setup.renderTrustedMarkdown(
          _vm.$t(
            'impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.optionsHeader',
          ),
        )
      )}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }